var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.0079C0 6.27156 6.27154 0 14.0078 0C21.52 0 27.651 5.91337 28 13.3392C26.3354 12.2497 24.3455 11.6163 22.2075 11.6163C16.3581 11.6163 11.6162 16.3582 11.6162 22.2076C11.6162 24.3455 12.2497 26.3355 13.3391 28C10.9464 27.8875 8.70993 27.1745 6.77808 26.0082C5.3556 26.5806 3.72274 27.1756 2.22878 27.5904C1.09657 27.9047 0.0762573 26.9315 0.363021 25.7831C0.750136 24.2327 1.34591 22.557 1.93783 21.1209C0.706479 19.0358 0 16.6038 0 14.0079Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 14C27.1944 14 31 17.8056 31 22.5C31 24.0645 30.577 25.5312 29.839 26.7908C30.1117 27.3831 30.3796 28.054 30.5956 28.7708C30.9401 29.9141 29.8998 30.9015 28.7766 30.5343C28.0957 30.3116 27.4503 30.0494 26.8713 29.7912C25.5939 30.5587 24.098 31 22.5 31C17.8056 31 14 27.1944 14 22.5C14 17.8056 17.8056 14 22.5 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.a23c5f7a5a9f40a6314bf90f9cb3c65f.svg";
export { ForwardRef as ReactComponent };